import * as React from 'react';
import { view, themeGlobals, useTokenContext } from '@sail/engine/deprecated';
export const LayerContext = /*#__PURE__*/ React.createContext(null);
export const ClassicLayerContext = /*#__PURE__*/ React.createContext(false);
/**
 * This context is used to determine if the classic layer should be rendered in the
 * `@sail/ui` `<RootLayer />` component and use Sail Next layering system.
 */ export const ClassicLayerSailNextContext = /*#__PURE__*/ React.createContext(false);
export const ClassicLayerCompat = view.div.create(function ClassicLayerCompat(props, View) {
    const tokens = useTokenContext();
    return(// eslint-disable-next-line react/jsx-boolean-value
    /*#__PURE__*/ React.createElement(ClassicLayerContext.Provider, {
        value: true
    }, /*#__PURE__*/ React.createElement(View, {
        uses: [
            props,
            themeGlobals,
            tokens.styles
        ]
    })));
});

//# sourceMappingURL=layer.js.map